export const corporate = {
  "hero": {
    "title": "A proposito di VIAGGIO D'ASINO",
    "subtitle": "Scopri la nostra storia, la nostra visione e il team appassionato che sta reinventando lo scambio casa per gli host più esigenti."
  },
  "mission": {
    "badge": "La nostra missione",
    "title": "Democratizzare i viaggi peer-to-peer premium",
    "description": "DONKEY TRAVEL nasce con una semplice ambizione: permettere anche ai migliori ospiti di godere dei frutti del proprio lavoro. Riteniamo che i proprietari di case eccezionali, con rating 4.5 e superiore, meritino una piattaforma dedicata dove poter scambiare le loro proprietà con fiducia, senza gli attriti finanziari degli affitti tradizionali."
  },
  "philosophy": {
    "badge": "Filosofia e valori",
    "title": "Nel cuore del nostro club",
    "description": "Non siamo solo una piattaforma, siamo una comunità costruita sulla fiducia, sul rispetto reciproco e sull'eccellente ospitalità.",
    "values": {
      "fair": {
        "title": "Equità",
        "desc": "Il nostro sistema commerciale è progettato per essere giusto e trasparente. Offri tempo nel tuo alloggio, risparmi tempo per viaggiare. È semplice, senza costi nascosti."
      },
      "local": {
        "title": "Immersione",
        "desc": "Lo scambio di casa è l'opportunità di vivere come una persona del posto, scoprire regioni fuori dai sentieri battuti e creare connessioni autentiche."
      },
      "community": {
        "title": "Fiducia",
        "desc": "Riservando il nostro club agli ospiti con punteggio 4,5+, garantiamo un livello impeccabile di requisiti e qualità all'interno della nostra rete."
      }
    }
  },
  "team": {
    "badge": "La squadra",
    "title": "Dietro VIAGGIO D'ASINO",
    "subtitle": "Una piattaforma nata dalla passione per i viaggi e l'ospitalità.",
    "members": {
      "ceo": {
        "name": "Silvano",
        "role": "Fondatore e amministratore delegato",
        "bio": "Ospite appassionato da anni, Sylvain ha immaginato DONKEY TRAVEL da solo alla ricerca di una soluzione per viaggiare gratuitamente promuovendo al contempo il proprio alloggio. Spinto dal desiderio di creare il miglior club di scambio europeo, garantisce ogni giorno l’eccellenza della comunità."
      }
    }
  },
  "investors": {
    "badge": "Investitori e partner",
    "title": "Unisciti all'avventura",
    "description": "DONKEY TRAVEL sta crescendo e siamo sempre aperti a opportunità strategiche per accelerare il nostro sviluppo in tutta Europa.",
    "cta": "Contattaci"
  }
};
